import React, { useState } from "react";
import styles from "./personalProjects.module.css";
import { Paper } from "@material-ui/core";
import { Grid } from "@material-ui/core";
import Figure from "react-bootstrap/Figure";
import boggle from "./boggle.jpg";
import chess from "./chess.png";
import decryptor from "./decryptor.jpeg";
import splendor from "./splendor.jpg";

function PersonalProjects() {
  return (
    <Paper>
      <section class="experience">
        <h2>Personal Projects</h2>
            <Grid container justify="center" alignItems="center" direction="row">
            <Grid item xs={3}>
              <Figure>
                <Figure.Image
                  width={200}
                  height={200}
                  alt="171x180"
                  src={boggle}
                />
              </Figure>
            </Grid>

            <Grid item xs={9}>
              
                <header>
                  <p className={styles.job_title}>
                    {" "}
                    <strong>Online Boggle</strong>
                  </p>
                </header>
                <ul>
                  <li>
                  	Wrote a browser based online multiplayer Boggle game using Node.js, Socket.io and React.
                  </li>
                  <li>
                  Implemented DFS graph traversals with a Trie dictionary to verify and autosolve each board upon game end.
                  </li>
                </ul>
             
              <br></br>
            </Grid>

            <Grid item xs={3}>
              <Figure>
                <Figure.Image
                  width={200}
                  height={200}
                  alt="160x180"
                  src={chess}
                />
              </Figure>
            </Grid>

            <Grid item xs={9}>
             
                <header>
                  <p className={styles.job_title}>
                    {" "}
                    <strong>Chess Engine in C</strong> 
                  </p>
                </header>
                <ul>
                  <li>
                  Built a Chess Engine in C, used PERFT for thorough code testing.  
                  </li>
                  <li>
                  Used bitboards to represent board states in longs to optimize possible move generation.
                  </li>
                  <li>
                  Used bitboards to represent board states in longs to optimize possible move generation.
                  </li>
                </ul>
              
              <br></br>
            </Grid>
            <br></br>

            <Grid item xs={3}>
              <Figure>
                <Figure.Image
                  width={200}
                  height={200}
                  src={decryptor}
                  alt="171x180"
                />
              </Figure>
            </Grid>

            <Grid item xs={9}>
              
                <header>
                  <p className={styles.job_title}>
                    {" "}
                    <strong>Decryptor</strong>
                  </p>
                </header>
                <ul>
                  <li>
                  	Developed algorithms to break common ciphers (Vignere, Rail, Ceasar, etc.) using letter frequency analysis and statistical methods.
                  </li>
                  <li>
                  Wrote a Node.JS web client for users.
                  </li>
                </ul>
              
              <br></br>
            </Grid>


            <Grid item xs={3}>
              <Figure>
                <Figure.Image
                  width={200}
                  height={200}
                  src={splendor}
                  alt="171x180"
                />
              </Figure>
            </Grid>

            <Grid item xs={9}>
              
                <header>
                  <p className={styles.job_title}>
                    {" "}
                    <strong>Other Projects</strong>
                  </p>
                </header>
                <ul>
                  <li>
                  Splendor Clone: Built an OOP clone of the boardgame Splendor in C++.
                  </li>
                  <li>
                  Built a C++ file system manager optimized for indexing large directories fast with less memory
                  </li>
                  <li>
                  Built this website using React.js.
                  </li>
                </ul>
            
              <br></br>
            </Grid>

          </Grid>
        

      </section>
    </Paper>
  );
}

export default PersonalProjects;
